import { Controller } from '@hotwired/stimulus';
import { visit } from '@hotwired/turbo';
import { readQrCode, stopScan } from '../js/qr_reader';

// Scanner : un code lu ouvre l'adresse des actions
// (`actionsUrl`) : dans la Frame du résultat si la page en a une (cible
// `frame`, « Scanner un autre » proposé), sinon en page entière (le serveur mène
// à la fiche ou revient avec un message) ; caméra indisponible : message et
// « Scanner un autre » ; Frame sans réponse (réseau) : message et « Scanner un
// autre ». Saisie à la main (cible manual) : un code QR (préfixe connu,
// `codePrefixes`, et 10 caractères) est lu comme par la caméra, un autre
// texte part vers la recherche (envoi du formulaire). La caméra est arrêtée
// en quittant la page et n'est pas demandée par l'aperçu Turbo.
export default class extends Controller {
    static targets = ['video', 'message', 'rescan', 'frame', 'manual'];
    static values = { actionsUrl: String, codePrefixes: Array };

    connect() {
        // Aperçu Turbo (page en cache affichée avant la réponse) : pas de caméra.
        if (document.documentElement.hasAttribute('data-turbo-preview')) return;
        this.read();
    }

    disconnect() {
        this.stop();
    }

    rescan() {
        this.read();
    }

    async read() {
        this.stop();
        this.rescanTarget.hidden = true;
        this.videoTarget.hidden = false;
        this.messageTarget.textContent = '';
        if (this.hasFrameTarget) {
            this.frameTarget.removeAttribute('src');
            this.frameTarget.replaceChildren();
        }
        const scan = { isCurrent: () => this.current === scan };
        this.current = scan;
        let text;
        try {
            text = await readQrCode(this.videoTarget, scan);
        } catch (error) {
            if (this.current !== scan) return;
            this.videoTarget.hidden = true;
            this.rescanTarget.hidden = false;
            this.messageTarget.textContent = 'Caméra indisponible : autorisez la caméra pour cette page.';
            return;
        }
        if (this.current !== scan) return;
        this.found(text);
    }

    // Code lu (caméra, ou appelé directement) : adresse des actions ouverte.
    found(text) {
        this.stop();
        const url = new URL(this.actionsUrlValue, window.location.origin);
        url.searchParams.set('qr_code', text);
        if (!this.hasFrameTarget) {
            visit(url.pathname + url.search);
            return;
        }
        this.videoTarget.hidden = true;
        this.rescanTarget.hidden = false;
        this.messageTarget.textContent = '';
        this.frameTarget.src = url.pathname + url.search;
    }

    manual(event) {
        const text = this.manualTarget.value.trim().toUpperCase();
        const code = new RegExp(`^(${this.codePrefixesValue.join('|')})[A-Z0-9]{10}$`);
        if (this.codePrefixesValue.length === 0 || !code.test(text)) return;
        event.preventDefault();
        this.found(text);
    }

    // Chargement du résultat sans réponse (réseau) ; une action de la carte
    // n'est pas concernée.
    failed({ target }) {
        if (!this.hasFrameTarget || target !== this.frameTarget) return;
        this.videoTarget.hidden = true;
        this.rescanTarget.hidden = false;
        this.messageTarget.textContent = 'Lecture impossible, réessayez plus tard.';
    }

    stop() {
        stopScan(this.current, this.videoTarget);
        this.current = null;
    }
}
